// 9fbef606107a605d69c0edbcd8029e5d
import { getDateObject, getAPIConfig } from '@tcp/core/src/utils';
import { readCookie, setCookie } from '@tcp/core/src/utils/cookie.util';
import { executeExternalAPICall } from '@tcp/core/src/services/handler';
import logger from '@tcp/core/src/utils/loggerInstance';
import buildDYRequest from '@tcp/core/src/services/abstractors/common/recommendations/utils/dyRequestBuilder.js';

export function parseDyResponseGrouped(response) {
  if (!response?.choices?.length) return {};

  // Filter DECISION type choices and combine their payload data
  return response.choices.reduce((acc, choice) => {
    if (choice.type === 'DECISION' && choice.variations?.length > 0) {
      // Iterate through all variations and combine their data
      const combinedVariationData = choice.variations.reduce((varAcc, variation) => {
        const variationData = variation?.payload?.data || {};
        return {
          ...varAcc,
          ...variationData,
        };
      }, {});

      return {
        ...acc,
        ...combinedVariationData,
      };
    }
    return acc;
  }, {});
}

const getCookieValue = (key = '') => {
  const cookieValue = readCookie(key);
  let value = '';
  if (cookieValue && cookieValue !== 'null' && cookieValue !== 'undefined') {
    value = cookieValue;
  }

  return value;
};

const parseAndSetCookieOrSessionValue = ({ cookies, dyId, dySession }) => {
  if (dyId && dySession) return;
  if (!cookies) return;

  const serverCookie = cookies.find((c) => c.name === '_dyid_server');
  const sessionCookie = cookies.find((c) => c.name === '_dyjsession');

  if (!dyId && serverCookie) {
    setCookie({
      key: '_dyid_server',
      value: serverCookie.value || '',
      daysAlive: 365,
    });
  }

  if (!dySession && sessionCookie) {
    setCookie({ key: '_dyjsession', value: sessionCookie?.value || '' });
  }
};

export async function getDyABtests(payload) {
  const { pageType = '', groups = [], data = [], pathname, pageAttributes } = payload;
  const apiConfigObj = getAPIConfig();
  const { dyURL, dyAPIKey, locale } = apiConfigObj;

  const ip = getCookieValue('tcpIp');
  const dyId = getCookieValue('_dyid_server');
  const dySession = getCookieValue('_dyjsession') || '';
  const pathnameNew = pathname || window?.location.pathname;
  const reqBody = buildDYRequest({
    data,
    userId: dyId,
    sessionId: dySession,
    pageType,
    pageLocation: `${window?.location.origin}${pathnameNew}` || window?.location?.href,
    referrer: `${window?.location.origin}${pathnameNew}` || window?.location?.href,
    locale,
    groups,
    userAgent: navigator?.userAgent,
    ip,
    dateTime: getDateObject().toISOString(),
    consent: false,
    pageAttributes,
  });

  return executeExternalAPICall({
    webService: {
      method: 'POST',
      URI: dyURL,
    },
    body: reqBody,
    header: {
      'dy-api-key': dyAPIKey,
      accept: 'application/json',
      'content-type': 'application/json',
    },
  })
    .then((res) => {
      const response = res?.body;
      parseAndSetCookieOrSessionValue({ cookies: response?.cookies, dyId, dySession });
      return parseDyResponseGrouped(response);
    })
    .catch((err) => {
      logger.error('Error occurred in dyRecommendations at getDyRecommendations method -', {
        error: err,
        extraData: {
          payloadRecieved: payload,
        },
      });
      return {};
    });
}
